import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DaysDistribution } from 'src/app/commons/models/days-distribution.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as DaysDistributionActions from 'src/app/store/actions/days-distribution.actions';
import { AppState } from 'src/app/store/reducers';
import * as DaysDistributionSelectors from 'src/app/store/selectors/days-distribution.selectors';
import * as AuthSelectors from 'src/app/store/selectors/auth.selectors';

import { DaysDistributionFilters } from '../../../commons/models/days-distribution.model';
import { DaysDistributionsColumn } from '../days-distribution-list/days-distribution-list.component';



@Component({
  selector: 'app-days-distribution-selection',
  templateUrl: './days-distribution-selection.component.html',
  styleUrls: ['./days-distribution-selection.component.scss']
})
export class DaysDistributionSelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  daysDistributions: Observable<DaysDistribution[]>;
  filters: Observable<DaysDistributionFilters>;

  @Input()
  defaultFilters: DaysDistributionFilters = {
    search: "",
  }

  displayedColumns: DaysDistributionsColumn[] = ["date", "days", "actions"];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.daysDistributions = this.store$.pipe(select(DaysDistributionSelectors.getDaysDistributions), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new DaysDistribution(dto)) : null));
    this.total = this.store$.pipe(select(DaysDistributionSelectors.getTotalDaysDistributions), takeUntil(this.unsubscribe$));
    this.filters = this.store$.pipe(select(DaysDistributionSelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(DaysDistributionActions.loadDaysDistributions(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(DaysDistributionActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(DaysDistributionActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize }))
  }

  filtersChange(filters: DaysDistributionFilters) {
    this.store$.dispatch(DaysDistributionActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectDaysDistribution(daysDistribution: DaysDistribution) {
    if (daysDistribution) {
      this.store$.dispatch(DaysDistributionActions.daysDistributionSelected({ daysDistribution: daysDistribution.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(DaysDistributionActions.closeSelectionDialog())
  }
}
